import { AgAppConfigService } from '@ag/vc.ag-core/settings';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2 } from '@angular/core';
interface Scripts {
  name: string;
  src: string;
}
interface ScriptData {
  name: string;
  src: string;
  loaded: boolean;
}
@Injectable({
  providedIn: 'root'
})
export class ExternalScriptsLoaderService {
  ScriptStore: Scripts[] = [
    { name: 'omnichannelLib', src: AgAppConfigService.get<string>('OmnichannelLibScript') },
    { name: 'chatWidget', src: AgAppConfigService.get<string>('chatWidgetScript') },
    { name: 'signalR', src: AgAppConfigService.get<string>('signalRScript') },
    { name: 'AgentAvailability', src: AgAppConfigService.get<string>('AgentAvailabilityScript') }
  ];
  renderer: Renderer2; // Renderer cannot be instantiated in service, thus passing it from component
  private scripts: unknown = {};
  constructor(
    @Inject(DOCUMENT) private readonly document: Document
  ) {
    this.ScriptStore.forEach((script: Scripts) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src
      };
    });
  }
  load(...scripts: string[]): Promise<unknown[]> {
    const promises: unknown[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }
  loadScript(name: string): Promise<unknown> {
    return new Promise((resolve, _reject) => {
      const scriptData = this.scripts[name] as ScriptData;
      // resolve if already loaded
      if (scriptData.loaded) {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      } else {
        // load script
        const script = this.renderer.createElement('script') as HTMLScriptElement;
        script.type = 'text/javascript';
        script.src = scriptData.src;
        script.onload = () => {
          scriptData.loaded = true;
          resolve({ script: name, loaded: true, status: 'Loaded' });
        };
        script.onerror = (_error: unknown) => resolve({ script: name, loaded: false, status: 'Loaded' });
        this.renderer.appendChild(this.document.head, script);
      }
    });
  }
}
